/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Nav_Stock_In_NotesInputs */

const vi_sl_nav_stock_in_notes = /** @type {(inputs: Sl_Nav_Stock_In_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập`)
};

/**

* @param {Sl_Nav_Stock_In_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_nav_stock_in_notes = /** @type {((inputs?: Sl_Nav_Stock_In_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Nav_Stock_In_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_nav_stock_in_notes(inputs)
});